/**
 * Terminal — amber/green monochrome CRT. Leans hardest into the Alien "Mother"
 * vibe the .crt-terminal effect already evokes: phosphor-amber text on near-
 * black, warm glow. Pairs naturally with the existing scanline/grain overlays.
 */
export const terminal = {
  id: 'terminal',
  name: 'Terminal',
  assignable: true,
  mantine: {
    primaryColor: 'yellow',
    fontFamily: 'Rajdhani, sans-serif',
    headings: { fontFamily: 'Orbitron, sans-serif' },
  },
  cssVars: {
    '--bw-bg': 'radial-gradient(ellipse at 50% 20%, #141005 0%, #0b0900 60%, #050300 100%)',
    '--bw-body-color': '#ffce6a',
    '--bw-panel-bg': 'rgba(20, 15, 4, 0.94)',
    '--bw-panel-border': 'rgba(255, 176, 0, 0.18)',
    '--bw-accent': 'rgba(255, 176, 0, 1)',
    '--bw-glow-color': 'rgba(255, 176, 0, 0.3)',
    '--bw-glow-text-color': 'rgba(120, 255, 130, 0.45)',
    '--bw-body-font': "'Rajdhani', sans-serif",
    '--bw-heading-font': "'Orbitron', sans-serif",
    '--bw-heading-letter-spacing': '0.07em',
    '--bw-content-base': '1.125rem',
  },
}
